import {Col, Form, FormInstance, Input, Row, Switch, UploadFile} from "antd";
import "./style.less"
import {useEffect, useState} from "react";
import {StaffFormDataProps, StaffItem} from "../../../../types/staff";
import * as BUCKETS from "../../../../enums/buckets";
import Uploader from "../../../uploader/Uploader";
import TextEditor from "../../../text-editor/TextEditor";
import {getImageLink} from "../../../../helpers/mainHelpers";
import {useUploadController} from "../../../../controllers/upload-controller";

interface IStaffFormProps {
  staffForm: FormInstance;
  createStaffHandler: (data: StaffItem) => void,
  updateStaffHandler: (data: StaffItem) => void,
  selectedStaff: StaffItem | undefined
  staffRole: string
}

const StaffForm = (props: IStaffFormProps) => {
  const {staffForm, createStaffHandler, selectedStaff, staffRole, updateStaffHandler} = props
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])
  const [staffImage, setStaffImage] = useState<UploadFile[]>([])
  const [aboutStaff, setAboutStaff] = useState(selectedStaff?.about)
  const {fetchFilesHandler, currentFiles} = useUploadController()

  useEffect(() => {
    if (currentFiles.length) {
      const files = currentFiles.map((file) => {
        return {
          uid: file.$id,
          name: file.name,
          url: getImageLink({imageId: file.$id, bucketId: BUCKETS.MAIN}),
          response: {$id: file.$id}
        }
      })
      setUploadImages(files)
    }
  }, [currentFiles])

  useEffect(() => {
    if (selectedStaff) {
      const staffImageData = {
        uid: selectedStaff.image,
        name: "image",
        url: getImageLink({imageId: selectedStaff.image, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedStaff.image}
      }
      fetchFilesHandler({fileIds: selectedStaff.certificates, bucketId: BUCKETS.MAIN}) // check??
      setStaffImage([staffImageData])
    } else {
      setStaffImage([])
      setUploadImages([])
    }

  }, [selectedStaff])


  const submitButtonHandler = (formData: StaffFormDataProps) => {
    const staffData = {
      ...formData,
      image: staffImage[0].response.$id || "",
      certificates: uploadImages.map(image => image.response.$id as string),
      role: staffRole,
      about: aboutStaff || "",
    }
    if (selectedStaff) {
      // Update
      updateStaffHandler(staffData)
    } else {
      // Create
      createStaffHandler(staffData)
    }

  }


  return <Form form={staffForm} layout="vertical" className="staff_form" onFinish={submitButtonHandler}>
    <Row>
      <Form.Item label="Фото">
        <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={staffImage} setFiles={setStaffImage}/>
      </Form.Item>
    </Row>
    <Row gutter={[16, 0]}>
      <Col span={12}>
        <Form.Item name="fullName" label="ПІБ" rules={[{required: true}]}>
          <Input/>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="position" label="Посада" rules={[{required: true}]}>
          <Input/>
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[16, 0]}>
      <Col span={12}>
        <Form.Item name="helsiId" label="Ідентифікатор HELSI">
          <Input/>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item initialValue={false} name="appointmentAvailable" label="Запис доступний" valuePropName="checked">
          <Switch/>
        </Form.Item>
      </Col>
    </Row>
    <Form.Item name="about" label="Детальна інформація">
      <TextEditor value={aboutStaff} setValue={setAboutStaff}/>
    </Form.Item>
    <Form.Item name="certificates" label="Сертифікати">
      <Uploader files={uploadImages} setFiles={setUploadImages} bucketId={BUCKETS.MAIN}/>
    </Form.Item>

  </Form>
}

export default StaffForm